import JQueryView, { on } from '../../../../../../common/views/jqueryView';
import $ from 'jquery';

export default class ConfirmView extends JQueryView {
  constructor() {
    super('.my.investors.specific_applications.users.confirm');

    this.render();
  }

  @on({ event: 'change', selector: '#check-consent' })
  onChangeCheckConsent() {
    this.render();
  }

  @on({ event: 'change', selector: '#check-in-july' })
  onChangeCheckInJuly() {
    this.render();
  }

  @on({ event: 'click', selector: '#complete-link' })
  onCompleteLink() {
    $('#complete-link').addClass('disabled');
  }

  render() {
    // 8月1日以降の更新のチェックボックスがなければチェック扱いとする
    const isCheckedInJuly =
      $('#check-in-july').prop('checked') || $('#check-in-july').length === 0;

    if ($('#check-consent').prop('checked') && isCheckedInJuly) {
      $('#complete-link').removeClass('disabled');
    } else {
      $('#complete-link').addClass('disabled');
    }
  }
}
